var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "producttracker-data" },
    [
      _c("div", { staticClass: "product-container" }, [
        _c("div", { staticClass: "row m-0" }, [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass:
                "col-lg-6 col-md-8 col-sm-8 col-xs-12 p-0 xs-mt-20 custom-display",
            },
            [
              _c(
                "div",
                {
                  staticClass: "wd-370",
                  class: {
                    "mr-20": _vm.permissions.includes(
                      "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_ADD_NEW_PRODUCT"
                    ),
                  },
                },
                [
                  _c("search-box", {
                    on: {
                      getList: function ($event) {
                        return _vm.getList()
                      },
                    },
                    model: {
                      value: _vm.searchText,
                      callback: function ($$v) {
                        _vm.searchText = $$v
                      },
                      expression: "searchText",
                    },
                  }),
                ],
                1
              ),
              _vm.permissions.includes(
                "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_ADD_NEW_PRODUCT"
              )
                ? _c(
                    "button",
                    {
                      staticClass: "btn emergo-green-button",
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#confrimAddPopup",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "margin-btn-plus-icon",
                        attrs: {
                          src: "/static/images/icons/plus_icon.svg",
                          alt: "plus-icon",
                        },
                      }),
                      _vm._v("Add "),
                      _c("span", { staticClass: "hidden-xs" }, [
                        _vm._v("New Product"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]),
        _c("div", { staticClass: "row m-0" }, [
          _c("div", { staticClass: "col-xs-12 p-0" }, [
            _c("div", { staticClass: "header_box pb-20" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _vm._m(1),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "bottom-end",
                            trigger: "click",
                            "popper-class":
                              "popup-background xs-popup-background pl-18",
                            width: "600",
                          },
                          on: {
                            show: function ($event) {
                              _vm.infoActive = true
                            },
                            hide: function ($event) {
                              _vm.infoActive = false
                            },
                          },
                        },
                        [
                          !_vm.infoActive
                            ? _c("img", {
                                staticClass: "info-img pr-10",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon.svg",
                                  alt: "info-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _vm.infoActive
                            ? _c("img", {
                                staticClass: "info-img pr-10",
                                attrs: {
                                  slot: "reference",
                                  src: "/static/images/icons/info_icon_active.svg",
                                  alt: "infoactive-icon",
                                },
                                slot: "reference",
                              })
                            : _vm._e(),
                          _c("div", { staticClass: "info-tabs" }, [
                            _c("p", { staticClass: "info-tabs-header" }, [
                              _vm._v("Product Status information:"),
                            ]),
                            _c(
                              "ul",
                              { staticClass: "pt-10 pl-20 pr-20" },
                              _vm._l(
                                _vm.metaData.work_flow_statuses,
                                function (role, index) {
                                  return _c("li", { key: index }, [
                                    _c("div", { staticClass: "info-text" }, [
                                      _c("span", { staticClass: "role-name" }, [
                                        _vm._v(_vm._s(role.name) + ":"),
                                      ]),
                                      _c("span", { staticClass: "role-desc" }, [
                                        _vm._v(" " + _vm._s(role.description)),
                                      ]),
                                    ]),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "row m-0" }, [
          _c("div", { staticClass: "col-xs-12 p-0" }, [
            _c("div", { staticClass: "header_box" }, [
              _c("div", { staticClass: "row m-0" }, [
                _c("div", { staticClass: "col-sm-5 pl-0" }, [
                  _c("p", { staticClass: "product-count" }, [
                    _vm._v(_vm._s(_vm.products.length || 0) + " Products"),
                  ]),
                ]),
                _vm.products.length || _vm.isRemovedflag || _vm.total
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-7 p-0 display-flex sm-justify-content-end xs-mt-20",
                      },
                      [
                        _vm.permissions.includes(
                          "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_UPDATE"
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "cursor-pointer pr-20",
                                attrs: {
                                  disabled:
                                    _vm.selectedProducts.length < 2 ||
                                    _vm.isRemovedflag,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openRequestModification("bulk")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "header-img-size",
                                  attrs: {
                                    src: "/static/images/icons/modification_icon.svg",
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "header-font text-emergo-dark-blue",
                                  },
                                  [_vm._v(" Bulk Request Update ")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.total || _vm.isRemovedflag
                          ? _c("div", [
                              _c(
                                "span",
                                { staticClass: "checkbox mr-12 top-4" },
                                [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isRemovedflag,
                                          expression: "isRemovedflag",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.isRemovedflag
                                        )
                                          ? _vm._i(_vm.isRemovedflag, null) > -1
                                          : _vm.isRemovedflag,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = _vm.isRemovedflag,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.isRemovedflag =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.isRemovedflag = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.isRemovedflag = $$c
                                            }
                                          },
                                          _vm.removeSelected,
                                        ],
                                      },
                                    }),
                                    _c("span", { staticClass: "cr" }),
                                  ]),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "header-font removed-label text-emergo-dark-blue",
                                },
                                [_vm._v(" Show Removed ")]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
        _vm.metaData.product_tracker_countries &&
        _vm.total &&
        _vm.checkAllMarkets()
          ? _c("div", { staticClass: "row m-0" }, [
              _c("div", { staticClass: "col-xs-12 p-0" }, [
                _c(
                  "ul",
                  { staticClass: "horizontal-tabs d-flex pl-10 mt-10" },
                  [
                    _vm._l(
                      _vm.metaData.product_tracker_countries,
                      function (country) {
                        return [
                          _vm.checkCountFromMarkets(country.country_id)
                            ? _c(
                                "li",
                                {
                                  key: country.country_id,
                                  staticClass: "cursor-pointer",
                                  class: {
                                    active:
                                      _vm.activeTab === country.country_id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setTab(country.country_id)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(country.name) + " ")]
                              )
                            : _vm._e(),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.products.length
        ? _c("div", { staticClass: "row m-0 position-relative" }, [
            _c("div", { staticClass: "col-xs-12 p-0" }, [
              _c("div", { staticClass: "rep_resources_table" }, [
                _c("table", { staticClass: "table" }, [
                  _c("thead", [
                    _c(
                      "tr",
                      {
                        class: { "custom-padding": !_vm.checkRolePermissions },
                      },
                      [
                        _vm.checkRolePermissions
                          ? [
                              _c("th", {
                                staticClass: "filter-th wd-65 sticky",
                                class: {
                                  "border-shadow": [12, 13].includes(
                                    _vm.roleId
                                  ),
                                },
                              }),
                              ![12, 13].includes(_vm.roleId)
                                ? _c(
                                    "th",
                                    { staticClass: "sticky-checkbox wd-40" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "checkbox top-2" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selectAllProducts,
                                                  expression:
                                                    "selectAllProducts",
                                                },
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                disabled: _vm.isRemovedflag,
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.selectAllProducts
                                                )
                                                  ? _vm._i(
                                                      _vm.selectAllProducts,
                                                      null
                                                    ) > -1
                                                  : _vm.selectAllProducts,
                                              },
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    var $$a =
                                                        _vm.selectAllProducts,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectAllProducts =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectAllProducts =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectAllProducts =
                                                        $$c
                                                    }
                                                  },
                                                  function ($event) {
                                                    return _vm.selectAll()
                                                  },
                                                ],
                                              },
                                            }),
                                            _c("span", { staticClass: "cr" }),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._l(_vm.headers, function (header) {
                          return [
                            !(
                              (_vm.activeTab === 14 || _vm.activeTab === 216) &&
                              header.key === "directives"
                            )
                              ? _c(
                                  "th",
                                  {
                                    key: header.key,
                                    attrs: {
                                      width: _vm.getHeaderWidth(header),
                                    },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(header.name) + " "),
                                    header.key !== "directives" &&
                                    header.key !== "trade_name"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "sort",
                                            class:
                                              _vm.sortOrders[header.key] > 0
                                                ? "asc"
                                                : "desc",
                                            on: {
                                              click: function ($event) {
                                                return _vm.sortBy(header.key)
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: "/static/images/icons/sortDesc.svg",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.products, function (each, index) {
                        return [
                          _c(
                            "tr",
                            {
                              key: index,
                              class: {
                                "custom-padding": !_vm.checkRolePermissions,
                              },
                            },
                            [
                              _vm.checkRolePermissions
                                ? [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "menu-td sticky",
                                        class: {
                                          "border-shadow": [12, 13].includes(
                                            _vm.roleId
                                          ),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown dropdown-export export-activity-menu text-center",
                                            class: {
                                              "disable-three-dots":
                                                !_vm.checkMenuPermission(
                                                  each.workflow_status_id
                                                ),
                                            },
                                            attrs: {
                                              id: "trackerActionDots" + index,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: {
                                                  "data-toggle":
                                                    _vm.checkMenuPermission(
                                                      each.workflow_status_id
                                                    )
                                                      ? "dropdown"
                                                      : false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.checkMenuPermission(
                                                      each.workflow_status_id
                                                    )
                                                      ? _vm.menuDropdown($event)
                                                      : null
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "dropdown-toggle",
                                                }),
                                              ]
                                            ),
                                            each.workflow_status_id !== 6
                                              ? [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu",
                                                      class: _vm.changeClass
                                                        ? "addReverse"
                                                        : "",
                                                    },
                                                    [
                                                      each.workflow_status_id >
                                                      1
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue menu-dots-links",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openInfoPopup(
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/info_icon.svg",
                                                                      alt: "convertion-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Info"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                      each.workflow_status_id >
                                                      1
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue menu-dots-links",
                                                                  attrs: {
                                                                    disabled:
                                                                      each.workflow_status_id >
                                                                      5,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openContactsInfoPopup(
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/info_icon.svg",
                                                                      alt: "convertion-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Project Contacts"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                      each.workflow_status_id ===
                                                        1 &&
                                                      _vm.permissions.includes(
                                                        "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_DRAFT"
                                                      )
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue menu-dots-links",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.editProductTracker(
                                                                          each.id,
                                                                          each.country_id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/edit_icon.svg",
                                                                      alt: "convertion-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Edit Draft"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                      each.workflow_status_id >
                                                        1 &&
                                                      each.workflow_status_id !==
                                                        5 &&
                                                      _vm.permissions.includes(
                                                        "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_EDIT_PRODUCT"
                                                      )
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue menu-dots-links",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.editProductTracker(
                                                                          each.id,
                                                                          each.country_id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/edit_icon.svg",
                                                                      alt: "convertion-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Edit Product"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                      each.workflow_status_id >
                                                        1 &&
                                                      _vm.permissions.includes(
                                                        "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_UPDATE"
                                                      )
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue menu-dots-links",
                                                                  attrs: {
                                                                    href: "javascript:void(0);",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openRequestModification(
                                                                          "single",
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/modification_icon.svg",
                                                                      alt: "convertion-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Request Update"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                      each.workflow_status_id >
                                                        1 &&
                                                      _vm.permissions.includes(
                                                        "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REQUEST_REMOVAL"
                                                      )
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-delete-red menu-dots-links",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openClientRemovalPopup(
                                                                          "single",
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/delete_icon.svg",
                                                                      alt: "delete-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Request Removal"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                      each.workflow_status_id >
                                                        1 &&
                                                      each.workflow_status_id !==
                                                        5 &&
                                                      _vm.permissions.includes(
                                                        "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_REMOVE_PRODUCT"
                                                      )
                                                        ? [
                                                            each.client_initiated_delete
                                                              ? _c(
                                                                  "li",
                                                                  [
                                                                    _c(
                                                                      "el-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "item",
                                                                        attrs: {
                                                                          effect:
                                                                            "light",
                                                                          content:
                                                                            "Allows the removal of a Product family after a client submitted a removal request via RAMS",
                                                                          placement:
                                                                            "top-start",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "text-color-delete-red menu-dots-links",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.openRemovalPopup(
                                                                                    "single",
                                                                                    each,
                                                                                    "client_initiated_delete"
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "tracker-images",
                                                                                attrs:
                                                                                  {
                                                                                    src: "/static/images/icons/delete_icon.svg",
                                                                                    alt: "delete-icon",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "Remove Product"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "li",
                                                              [
                                                                _c(
                                                                  "el-tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "item",
                                                                    attrs: {
                                                                      effect:
                                                                        "light",
                                                                      content:
                                                                        "Initiates the removal by PM. Client will receive an email, asking for confirmation of the removal.",
                                                                      placement:
                                                                        "bottom-start",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "text-color-delete-red menu-dots-links",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.openPMRequestRemovalPopup(
                                                                                "single",
                                                                                each,
                                                                                "client_initiated_delete"
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "tracker-images",
                                                                            attrs:
                                                                              {
                                                                                src: "/static/images/icons/delete_icon.svg",
                                                                                alt: "delete-icon",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Request Removal"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "dropdown-menu",
                                                      class: _vm.changeClass
                                                        ? "addReverse"
                                                        : "",
                                                    },
                                                    [
                                                      each.workflow_status_id >
                                                      1
                                                        ? [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue menu-dots-links",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openInfoPopup(
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "tracker-images",
                                                                    attrs: {
                                                                      src: "/static/images/icons/info_icon.svg",
                                                                      alt: "convertion-icon",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Info"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    ![12, 13].includes(_vm.roleId)
                                      ? _c(
                                          "td",
                                          { staticClass: "sticky-checkbox" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "checkbox top-2" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.selectedProducts,
                                                        expression:
                                                          "selectedProducts",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      disabled:
                                                        [1, 5, 6].includes(
                                                          each.workflow_status_id
                                                        ) ||
                                                        !_vm.checkMenuPermission(
                                                          each.workflow_status_id
                                                        ),
                                                    },
                                                    domProps: {
                                                      value: each,
                                                      checked: Array.isArray(
                                                        _vm.selectedProducts
                                                      )
                                                        ? _vm._i(
                                                            _vm.selectedProducts,
                                                            each
                                                          ) > -1
                                                        : _vm.selectedProducts,
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$a =
                                                              _vm.selectedProducts,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = each,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectedProducts =
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ]))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectedProducts =
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                            }
                                                          } else {
                                                            _vm.selectedProducts =
                                                              $$c
                                                          }
                                                        },
                                                        function ($event) {
                                                          return _vm.updateSelection(
                                                            each,
                                                            $event
                                                          )
                                                        },
                                                      ],
                                                    },
                                                  }),
                                                  _c("span", {
                                                    staticClass: "cr",
                                                  }),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _vm._l(_vm.headers, function (header, indexes) {
                                return [
                                  !(
                                    (_vm.activeTab === 14 ||
                                      _vm.activeTab === 216) &&
                                    header.key === "directives"
                                  )
                                    ? [
                                        Array.isArray(each[header.key])
                                          ? _c(
                                              "td",
                                              { key: indexes },
                                              [
                                                each[header.key].length > 1
                                                  ? _c(
                                                      "el-popover",
                                                      {
                                                        attrs: {
                                                          placement: "bottom",
                                                          trigger: "hover",
                                                          "visible-arrow":
                                                            "true",
                                                          "popper-class":
                                                            "custom-tradelist-popover",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "reference",
                                                            },
                                                            slot: "reference",
                                                          },
                                                          [
                                                            _vm._l(
                                                              each[
                                                                header.key
                                                              ].slice(0, 5),
                                                              function (
                                                                name,
                                                                i
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "span",
                                                                    { key: i },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            name
                                                                          ) +
                                                                          _vm._s(
                                                                            i !==
                                                                              each[
                                                                                header
                                                                                  .key
                                                                              ].slice(
                                                                                0,
                                                                                5
                                                                              )
                                                                                .length -
                                                                                1
                                                                              ? ", "
                                                                              : ""
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              }
                                                            ),
                                                            each[header.key]
                                                              .length > 5
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ft-20",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "..."
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "list",
                                                          },
                                                          [
                                                            _vm._l(
                                                              each[header.key],
                                                              function (
                                                                name,
                                                                i
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      key: i,
                                                                      staticClass:
                                                                        "ft-16",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            name
                                                                          ) +
                                                                          _vm._s(
                                                                            i !==
                                                                              each[
                                                                                header
                                                                                  .key
                                                                              ]
                                                                                .length -
                                                                                1
                                                                              ? ", "
                                                                              : ""
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._l(
                                                      each[header.key],
                                                      function (name, i) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            { key: i },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(name) +
                                                                  _vm._s(
                                                                    i !==
                                                                      each[
                                                                        header
                                                                          .key
                                                                      ].length -
                                                                        1
                                                                      ? ", "
                                                                      : ""
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      }
                                                    ),
                                              ],
                                              2
                                            )
                                          : header.key === "workflow_status_id"
                                          ? _c(
                                              "td",
                                              { key: indexes },
                                              [
                                                _vm.metaData
                                                  .work_flow_statuses &&
                                                _vm.permissions.includes(
                                                  "REPRESENTATION_RESOURCES_PRODUCT_TRACKER_CHANGE_STATUS"
                                                )
                                                  ? _c(
                                                      "multiselect",
                                                      {
                                                        staticClass:
                                                          "multiselect-single-dropdown status-dropdown",
                                                        class:
                                                          each[header.key] ===
                                                            1 ||
                                                          each[header.key] ===
                                                            5 ||
                                                          each[header.key] === 6
                                                            ? "disable-drop-down"
                                                            : "",
                                                        attrs: {
                                                          showLabels: false,
                                                          "close-on-select": true,
                                                          "allow-empty": false,
                                                          searchable: false,
                                                          options:
                                                            _vm.filteredOptions(
                                                              each[header.key]
                                                            ),
                                                          label: "name",
                                                          value: _vm.getStatus(
                                                            each[header.key]
                                                          ),
                                                          placeholder:
                                                            "Select Status",
                                                          disabled:
                                                            each[header.key] ===
                                                              1 ||
                                                            each[header.key] ===
                                                              5 ||
                                                            each[header.key] ===
                                                              6,
                                                        },
                                                        on: {
                                                          select: function (
                                                            $event
                                                          ) {
                                                            return _vm.updateStatusCall(
                                                              $event,
                                                              each
                                                            )
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "option",
                                                              fn: function (
                                                                props
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {},
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          props
                                                                            .option
                                                                            .name
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "noResult",
                                                            },
                                                            slot: "noResult",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "No matching data"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("div", [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getStatusName(
                                                              each[header.key]
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      each[header.key] === 5 &&
                                                      each.pm_delete_request_to_id ===
                                                        _vm.userId
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pt-10",
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-color-blue custom-margin-right fw-500",
                                                                  attrs: {
                                                                    href: "javascript:void(0);",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.approvedRequest(
                                                                          "approval",
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Approve"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-emergo-red fw-500",
                                                                  attrs: {
                                                                    href: "javascript:void(0);",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.approvedRequest(
                                                                          "denial",
                                                                          each
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("Deny")]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                              ],
                                              1
                                            )
                                          : _c("td", { key: indexes }, [
                                              _vm._v(_vm._s(each[header.key])),
                                            ]),
                                      ]
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      ((!_vm.products.length && !this.searchText) || !_vm.total) &&
      _vm.initialCalls
        ? _c("div", { staticClass: "row m-0 mt-10" }, [
            _c("div", { staticClass: "notification_box" }, [
              _c("div", { staticClass: "row m-0 center" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-xs-12 notification_text" }, [
                  _vm._v(" No product have been "),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.isRemovedflag ? "removed" : "added") +
                      " yet. "
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      !_vm.products.length && this.searchText && _vm.initialCalls
        ? _c("div", { staticClass: "row m-0 mt-10" }, [_vm._m(3)])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "requestModificationPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header generic-header" }, [
                _c("span", [_vm._v("Request Update")]),
                _c("img", {
                  staticClass: "close-icon cursor-pointer",
                  attrs: { src: "/static/images/icons/close_icon.svg" },
                  on: { click: _vm.closeRequestPopup },
                }),
              ]),
              _c("div", { staticClass: "modal-body generic-body" }, [
                _c("div", {}, [
                  _c("div", { staticClass: "form-group" }, [
                    _vm._v(
                      "What kind of modifications would you like to make?"
                    ),
                  ]),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.requestModificationMessage,
                        expression: "requestModificationMessage",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control text-box",
                    attrs: { placeholder: "Message" },
                    domProps: { value: _vm.requestModificationMessage },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.requestModificationMessage =
                          $event.target.value.trim()
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "modal-footer", staticStyle: { clear: "both" } },
                [
                  _c("div", { staticClass: "col-xs-6 pl-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button",
                        attrs: { type: "button" },
                        on: { click: _vm.closeRequestPopup },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ]),
                  _c("div", { staticClass: "col-xs-6 pr-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target":
                            "#clientModificationRequestConfirmationPopup",
                          disabled: !_vm.requestModificationMessage,
                        },
                      },
                      [_vm._v(" Proceed ")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: {
            id: "clientModificationRequestConfirmationPopup",
            role: "dialog",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _vm._m(4),
                _vm._m(5),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { clear: "both" },
                  },
                  [
                    _vm._m(6),
                    _c("div", { staticClass: "col-xs-6 pr-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: { click: _vm.requestModification },
                        },
                        [_vm._v(" Submit ")]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: {
                    loadingStatus: _vm.loaderStatus === "requestModification",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: { id: "clientRequestRemovalPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _vm._m(7),
                _vm._m(8),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { clear: "both" },
                  },
                  [
                    _c("div", { staticClass: "col-xs-6 pl-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-white-button",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "data-target": "#clientRequestRemovalPopup",
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectedProductType = ""
                              _vm.selectedSingleProduct = null
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-xs-6 pr-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.submitRequestRemoval()
                            },
                          },
                        },
                        [_vm._v(" Submit ")]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: {
                    loadingStatus: _vm.loaderStatus === "requestRemoveProduct",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: { id: "confirmProductRemoval", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _vm._m(9),
                _vm._m(10),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { clear: "both" },
                  },
                  [
                    _c("div", { staticClass: "col-xs-6 pl-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-white-button",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "data-target": "#confirmProductRemoval",
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectedProductType = ""
                              _vm.selectedSingleProduct = null
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-xs-6 pr-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.removeSelectedProducts()
                            },
                          },
                        },
                        [_vm._v(" Submit ")]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: {
                    loadingStatus: _vm.loaderStatus === "removeProduct",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: { id: "approveRequestPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _vm._m(11),
                _c("div", { staticClass: "modal-body center pt-0" }, [
                  _c("img", {
                    staticClass: "info-icon",
                    attrs: { src: "/static/images/icons/expiring_yellow.svg" },
                  }),
                  _c("div", { staticClass: "sub-header" }, [
                    _vm._v(
                      " Are you sure you would like to " +
                        _vm._s(
                          this.selectedProductType === "approval"
                            ? "approve"
                            : "deny"
                        ) +
                        " this request? "
                    ),
                  ]),
                  _c("div", { staticClass: "sub-text" }, [
                    _c("div", [
                      _vm._v(
                        " Once you proceed, you will not be able to undo the action. PM will be notified about the " +
                          _vm._s(this.selectedProductType) +
                          ". "
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { clear: "both" },
                  },
                  [
                    _c("div", { staticClass: "col-xs-6 pl-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-white-button",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "data-target": "#approveRequestPopup",
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectedProductType = ""
                              _vm.selectedSingleProduct = null
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-xs-6 pr-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.approvedProductRequest()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                this.selectedProductType === "approval"
                                  ? "Approve"
                                  : "Deny"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: {
                    loadingStatus: _vm.loaderStatus === "approveProduct",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "requestRemoveProductPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c(
                  "div",
                  { staticClass: "modal-header generic-header pb-15" },
                  [
                    _c("span", [_vm._v("Select Contacts to Notify")]),
                    _c("img", {
                      staticClass: "close-icon cursor-pointer",
                      attrs: {
                        src: "/static/images/icons/close_icon.svg",
                        "data-dismiss": "modal",
                        "data-target": "requestRemoveProductPopup",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.primaryUser = null), (_vm.secondaryUsers = [])
                        },
                      },
                    }),
                  ]
                ),
                _c("div", { staticClass: "modal-body generic-body" }, [
                  _vm._m(12),
                  _c("div", { staticClass: "row mb-15" }, [
                    _vm._m(13),
                    _c(
                      "div",
                      { staticClass: "col-xs-12" },
                      [
                        _c(
                          "multiselect",
                          {
                            staticClass: "multiselect-single-dropdown",
                            class: !_vm.primaryUser ? "un-selected" : "",
                            attrs: {
                              showLabels: false,
                              "close-on-select": true,
                              searchable: true,
                              options: _vm.usersList.map((e) => e.user_id),
                              "custom-label": _vm.getUserFullName,
                              placeholder: "Select Contact",
                            },
                            model: {
                              value: _vm.primaryUser,
                              callback: function ($$v) {
                                _vm.primaryUser = $$v
                              },
                              expression: "primaryUser",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [_vm._v("No matching data")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm.primaryUser
                      ? _c("div", { staticClass: "mt-20 col-xs-12" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "selected-names text-capitalize mb-20",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getContact(_vm.primaryUser).first_name
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.getContact(_vm.primaryUser).last_name
                                  ) +
                                  " "
                              ),
                              _c("img", {
                                staticClass: "ml-10 cursor-pointer",
                                attrs: {
                                  src: "/static/images/icons/close_blue_icon.svg",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.primaryUser = null
                                  },
                                },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { clear: "both" },
                  },
                  [
                    _c("div", { staticClass: "col-xs-6 pl-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-white-button",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "data-target": "requestRemoveProductPopup",
                          },
                          on: {
                            click: function ($event) {
                              ;(_vm.primaryUser = null),
                                (_vm.secondaryUsers = [])
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-xs-6 pr-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button", disabled: !_vm.primaryUser },
                          on: { click: _vm.removeProductRequestByPM },
                        },
                        [_vm._v(" Proceed ")]
                      ),
                    ]),
                  ]
                ),
                _c("loader", {
                  attrs: {
                    loadingStatus:
                      _vm.loaderStatus === "requestRemoveProductPopup",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "productTrackerInfoPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog info-popup" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", [_vm._v("Info")]),
                  _c("img", {
                    staticClass: "close-icon cursor-pointer",
                    attrs: {
                      src: "/static/images/icons/close_icon.svg",
                      "data-dismiss": "modal",
                      "data-target": "productTrackerInfoPopup",
                    },
                    on: {
                      click: function ($event) {
                        _vm.productInfoData = []
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "modal-body generic-body" }, [
                  _c("div", { staticClass: "modal-status-header pt-15" }, [
                    _vm._v("Status updates:"),
                  ]),
                  _c("div", { staticClass: "info-table" }, [
                    _c("table", { staticClass: "table status-table mt-20" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          {
                            class: {
                              "custom-padding": !_vm.checkRolePermissions,
                            },
                          },
                          [
                            _vm._l(_vm.infoheaders, function (header, index) {
                              return [
                                _c("th", { key: index }, [
                                  _vm._v(_vm._s(header.name)),
                                ]),
                              ]
                            }),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.productInfoData, function (data, index) {
                            return _c(
                              "tr",
                              { key: index },
                              [
                                _vm._l(
                                  _vm.infoheaders,
                                  function (header, headerindex) {
                                    return [
                                      _c("td", { key: headerindex }, [
                                        header.key === "modified_on"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("infoDate")(
                                                    data[header.key]
                                                  )
                                                )
                                              ),
                                            ])
                                          : header.key === "updated_by" ||
                                            header.key === "requested_by"
                                          ? _c("span", [
                                              ![12, 13].includes(_vm.roleId) &&
                                              data[header.key].role_id &&
                                              [12, 13].includes(
                                                data[header.key].role_id
                                              )
                                                ? _c("img", {
                                                    staticClass:
                                                      "emergo-record test",
                                                    attrs: {
                                                      src: "/static/images/icons/emergo_record.svg",
                                                      alt: "",
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center",
                                                    },
                                                    [
                                                      data[header.key].name
                                                        ? _c("img", {
                                                            staticClass:
                                                              "profile-img",
                                                            attrs: {
                                                              src: "/static/images/icons/profile_icon.svg",
                                                              alt: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            data[header.key]
                                                              .name || "-"
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(data[header.key] || "-")
                                              ),
                                            ]),
                                      ]),
                                    ]
                                  }
                                ),
                              ],
                              2
                            )
                          }),
                          !_vm.productInfoData.length
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "center",
                                    attrs: { colspan: "100%" },
                                  },
                                  [_vm._v("No Status updates")]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
                _c("loader", {
                  attrs: { loadingStatus: _vm.loaderStatus === "infopage" },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade submit-popup",
          attrs: { id: "confrimAddPopup", role: "dialog" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(14),
              _vm._m(15),
              _c(
                "div",
                { staticClass: "modal-footer", staticStyle: { clear: "both" } },
                [
                  _vm._m(16),
                  _c("div", { staticClass: "col-xs-6 pr-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.openAddProductTracker()
                          },
                        },
                      },
                      [_vm._v(" Proceed ")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _c("contacts-popup", {
        attrs: {
          checkRolePermissions: _vm.checkRolePermissions,
          selectedSingleProduct: _vm.selectedSingleProduct,
          usersListData: _vm.usersList,
          countries: _vm.metaData.product_tracker_countries,
        },
        on: {
          close: function ($event) {
            _vm.selectedSingleProduct = null
          },
        },
      }),
      _c("loader", {
        attrs: { loadingStatus: _vm.loaderStatus === "listpage" },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm-4 col-lg-6 col-xs-12 p-0" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Product Tracker")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "pr-30 xs-pr-10" }, [
      _vm._v(
        ' With the Product Tracker you can manage the products that are being represented by Emergo. You can request additions, modifications, and removals of product families to and from your representation agreement. The product tracker will indicate the status of each product family. Only product families with a status of "Represented" or "Registered and Represented" can be marketed by you with Emergo as the in-country representative. You can see a definition of each status by clicking on the information icon on the right. '
      ),
      _c("br"),
      _vm._v(
        "The product tracker is currently being used for representation in Australia, the EU, Switzerland, and the UK. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("img", {
        attrs: {
          src: "/static/images/icons/info_icon.svg",
          width: "32px",
          height: "32px",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "notification_box" }, [
      _c("div", { staticClass: "row m-0 center" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("img", {
            attrs: {
              src: "/static/images/icons/info_icon.svg",
              width: "32px",
              height: "32px",
            },
          }),
        ]),
        _c("div", { staticClass: "col-xs-12 notification_text" }, [
          _vm._v("No products found."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#clientModificationRequestConfirmationPopup",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/expiring_yellow.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v("Are you sure you want to submit the modification request?"),
      ]),
      _c("div", { staticClass: "sub-text" }, [
        _vm._v(
          " This will send an email to Project Manager for modifications. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-6 pl-0" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-white-button",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "data-target": "#clientModificationRequestConfirmationPopup",
          },
        },
        [_vm._v(" Cancel ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#clientRequestRemovalPopup",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/expiring_yellow.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v("Are you sure you want to submit the removal request?"),
      ]),
      _c("div", { staticClass: "sub-text" }, [
        _vm._v(
          " This will send an email to Project Manager for removal. Once they delete the product, Emergo will no longer represent you for this product but the information will remain in the product tracker. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#confirmProductRemoval",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/expiring_yellow.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v(
          " Are you sure you would like to delete the selected product(s)? "
        ),
      ]),
      _c("div", { staticClass: "sub-text" }, [
        _c("div", [
          _vm._v(" Once deleted, you cannot recover the "),
          _c("br"),
          _vm._v(" information again. "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#approveRequestPopup",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-10" }, [
      _c("p", { staticClass: "col-xs-12 modal-status-header pr-0" }, [
        _vm._v(
          " Please select the required contacts before removing products: "
        ),
      ]),
      _c("p", { staticClass: "col-xs-12 modal-note pr-0" }, [
        _vm._v(
          " The selected contacts will be notified after the removal is initiated. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-label col-xs-12" }, [
      _vm._v("To"),
      _c("span", { staticClass: "required-astreisk" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header generic-header" }, [
      _c("img", {
        staticClass: "close-icon cursor-pointer",
        attrs: {
          src: "/static/images/icons/close_icon.svg",
          "data-dismiss": "modal",
          "data-target": "#confrimAddPopup",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body center pt-0" }, [
      _c("img", {
        staticClass: "info-icon",
        attrs: { src: "/static/images/icons/info_icon_active.svg" },
      }),
      _c("div", { staticClass: "sub-header" }, [
        _vm._v("Only add product if instructed to do so by Emergo"),
      ]),
      _c("div", { staticClass: "sub-text" }, [
        _vm._v(
          " Please proceed, if you are sure about adding the product as per the instructions of Emergo. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-6 pl-0" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-block emergo-white-button",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "data-target": "#confrimAddPopup",
          },
        },
        [_vm._v(" Cancel ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }